import styled from 'styled-components';
import { ZIndex } from 'web-common/src/shared/styles';
import { ScrollablePaneFooter } from '../ScrollablePaneFooter';

// NOTE: Just an extension of a non-sticky footer
//       Can live on its own in a mobile view
export const MobileStickyFooter = styled(ScrollablePaneFooter)`
  position: sticky;
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: ${ZIndex.StickyFooter};
`;
